import * as React from 'react';

function OccupancyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.427 6.503a1.033 1.033 0 1 0 0-2.067 1.033 1.033 0 0 0 0 2.067m2.534-1.034a2.533 2.533 0 1 1-5.067 0 2.533 2.533 0 0 1 5.067 0m8.606 1.034a1.033 1.033 0 1 0 0-2.067 1.033 1.033 0 0 0 0 2.067M20.1 5.469a2.533 2.533 0 1 1-5.067 0 2.533 2.533 0 0 1 5.067 0m-9.22 7.341a3.564 3.564 0 0 0-3.565-3.563H5.54a3.565 3.565 0 0 0-3.564 3.564v8.253h8.911v-8.253zm-1.494 1.501H9.38v-1.5c0-1.14-.923-2.064-2.064-2.064H5.54c-1.14 0-2.064.924-2.064 2.064v6.753h5.911zm12.633-1.501a3.564 3.564 0 0 0-3.564-3.563h-1.776a3.565 3.565 0 0 0-3.565 3.564v8.253h8.911v-8.253zm-1.494 1.501h-.006v-1.5c0-1.14-.924-2.064-2.064-2.064h-1.776c-1.14 0-2.065.924-2.065 2.064v6.753h5.911z"
  }));
}

export { OccupancyIcon };
